export { default as IndexTableCellLink } from './IndexTableCellLink';
